export default Object.freeze({
    'Glucobay': 'acarbose',
    'Aglucose': 'acarbose',
    'Pred Mild': 'acetato de prednisolona - oftalmologico',
    'Prefort': 'acetato de prednisolona - oftalmologico',
    'Ster': 'acetato de prednisolona - oftalmologico',
    'Diamox': 'acetazolamida',
    'Ipsilon': 'acido epsilon-aminocaproico',
    'Transamin': 'acido tranexamico',
    'Hemoblock': 'acido tranexamico',
    'Fluimucil': 'acetilcisteina',
    'Aspirina': 'acido acetilsalicilico',
    'Aas': 'acido acetilsalicilico',
    'Mebenix': 'albendazol',
    'Minusorb': 'alendronato',
    'Aranesp': 'alfadarbepoetina',
    'Ursacol': 'acido ursodesoxicolico',
    'Zyloric': 'alopurinol',
    'Frontal': 'alprazolam',
    'Clavulin': 'amoxicilina + clavulanato de potassio',
    'Pressat': 'anlodipino',
    'Nebacetin': 'bacitracina',
    'Anaseptil': 'bacitracina',
    'Bacigen': 'bacitracina',
    'Lioresal': 'baclofeno',
    'Lotensin': 'benazepril',
    'Glaucur': 'bimatoprosta - oftalmologico',
    'Lumigan': 'bimatoprosta - oftalmologico',
    'Dulcolax': 'bisacodil',
    'Bisalax': 'bisacodil',
    'Lacto Purga': 'bisacodil',
    'Parlodel': 'bromocriptina',
    'Entocort': 'budesonida',
    'Neocaína': 'bupivacaina',
    'Ansitec': 'buspirona',
    'Dostinex': 'cabergolina',
    'Coreg': 'carvedilol',
    'Keflin': 'cefalotina sodica',
    'Kefazol': 'cefazolina sodica',
    'Ketamina': 'cetamina',
    'Quetamina': 'cetamina',
    'Profenid': 'cetoprofeno',
    'Cicloplegico': 'ciclopentolato',
    'Sandimmun': 'ciclosporina',
    'Fauldcita': 'citarabina/citosina arabinosideo',
    'Cytos': 'citarabina/citosina arabinosideo',
    'Citarax': 'citarabina/citosina arabinosideo',
    'Fentanil': 'citrato de fentanila',
    'Agasten': 'clemastina',
    'Anafranil': 'clomipramina',
    'Rivotril': 'clonazepam',
    'Zilepam': 'clonazepam',
    'Plavix': 'clopidogrel',
    'Plaquevix': 'clopidogrel',
    'Arifenicol': 'cloranfenicol',
    'Amplicitil': 'clorpromazina',
    'Diabinese': 'clorpropamida',
    'Ladogal': 'danazol',
    'Eponim': 'dapsona',
    'Decadron': 'dexametasona',
    'Maxidex': 'dexametasona - oftalmologico',
    'Cardioxane': 'dexrazoxano',
    'Valium': 'diazepam',
    'Destilbenol': 'dietilestibestrol',
    'Cardcor': 'digoxina',
    'Cardizem': 'diltiazem',
    'Cordil': 'diltiazem',
    'Dramin': 'dimenidrinato',
    'Novalgina': 'dipirona',
    'Motilium': 'domperidona',
    'Ocupress': 'dorzolamida - oftalmologico',
    'Vibramicina': 'doxiciclina',
    'Renitec': 'enalapril',
    'Vasopril': 'enalapril',
    'Endocris': 'enoxaparina sodica',
    'Adren': 'epinefrina (adrenalina)',
    'Efrinalin': 'epinefrina (adrenalina)',
    'Eritromax': 'eritropoietina (alfaepoetina)',
    'Brevibloc': 'esmolol',
    'Nexium': 'esomeprazol',
    'Ovestrion': 'estriol',
    'Loteprol': 'etabonato de loteprednol - oftalmologico',
    'Alrex': 'etabonato de loteprednol - oftalmologico',
    'Hypnomidate': 'etomidato',
    'Gardenal': 'fenobarbital',
    'Carbital': 'fenobarbital',
    'Fenocris': 'fenobarbital',
    'Allegra': 'fexofenadina',
    'Propecia': 'finasterida',
    'Zoltec': 'fluconazol',
    'Florinefe': 'fludrocortisona',
    'Flixotide': 'fluticasona',
    'Lasix': 'furosemida',
    'Zymar': 'gatifloxacino – oftalmologico',
    'Gentagran': 'gentamicina - oftalmologico',
    'Amaryl': 'glimepirida',
    'Minidiab': 'glipizida',
    'Nepresol': 'hidralazina',
    'Apresolina': 'hidralazina',
    'Voluven': 'hidroxietilamido (hes)',
    'Hixizine': 'hidroxizina',
    'Aprovel': 'irbesartana',
    'Lactulona': 'lactulose',
    'Duphalac': 'lactulose',
    'Normolac': 'lactulose',
    'Fresh Tears': 'lagrimas artificiais - lubrificantes oculares',
    'Lacrifilm': 'lagrimas artificiais - lubrificantes oculares',
    'Lacrilax': 'lagrimas artificiais - lubrificantes oculares',
    'Acu Fresh': 'lagrimas artificiais - lubrificantes oculares',
    'Lacril': 'lagrimas artificiais - lubrificantes oculares',
    'Trisorb': 'lagrimas artificiais - lubrificantes oculares',
    'Lacrima Plus': 'lagrimas artificiais - lubrificantes oculares',
    'Hylo-comod': 'lagrimas artificiais - lubrificantes oculares',
    'Hylo-gel': 'lagrimas artificiais - lubrificantes oculares',
    'Neo Fresh': 'lagrimas artificiais - lubrificantes oculares',
    'Ascaridil': 'levamisol',
    'Keppra': 'levetiracetam',
    'Etira': 'levetiracetam',
    'Puran T4': 'levotiroxina sodica',
    'Levoid': 'levotiroxina sodica',
    'Synthroid Euthyrox': 'levotiroxina sodica',
    'Xylestesin': 'lidocaina',
    'Xylocaina': 'lidocaina – topico',
    'Labcaina': 'lidocaina – topico',
    'Lidogel': 'lidocaina – topico',
    'Imosec': 'loperamida',
    'Ansirax': 'lorazepam',
    'Timoptol': 'maleato de timolol - oftalmologico',
    'Timoneo': 'maleato de timolol - oftalmologico',
    'Glaucotrat': 'maleato de timolol - oftalmologico',
    'Meclin': 'meclizina',
    'Femigestrol': 'megestrol',
    'Dolosal': 'meperidina - petidina',
    'Mytedom': 'metadona',
    'Ritalina': 'metilfenidato',
    'Concerta': 'metilfenidato',
    'Unimedrol': 'metilprednisolona',
    'Solupren': 'metilprednisolona',
    'Depo-medrol': 'metilprednisolona - acetato',
    'Depomedrol': 'metilprednisolona - acetato',
    'Predi-medrol': 'metilprednisolona - acetato',
    'Predimedrol': 'metilprednisolona - acetato',
    'Solu-medrol': 'metilprednisolona - acetato',
    'Solumedrol': 'metilprednisolona - acetato',
    'Plasil': 'metoclopramida',
    'Betacris': 'metoprolol',
    'Flagyl': 'metronidazol',
    'Cellcept': 'micofenolato de mofetila',
    'Mofocell': 'micofenolato de mofetila',
    'Mofilen': 'micofenolato de mofetila',
    'Dormonid': 'midazolam',
    'Dormire': 'midazolam',
    'Razapina': 'mirtazapina',
    'Lisodren': 'mitotano',
    'Dimorf': 'morfina',
    'Vigamox': 'moxifloxacino - oftalmologico',
    'Bactroban': 'mupirocina - topico',
    'Maxitrol': 'mupirocina - topico',
    'Maxinom': 'neomicina + dexametasona + polimixina b – oftalmologico',
    'Normastig': 'neostigmina',
    'Nevanac': 'nepafenaco - oftalmologico',
    'Furacin': 'nitrofural/nitrofurazona - topico',
    'Macrodantina': 'nitrofurantoina',
    'Nitrofen': 'nitrofurantoina',
    'Sandostatin': 'octreotida',
    'Nujol': 'oleo mineral',
    'Lodina': 'olopatadina - oftalmologico',
    'Patanol': 'olopatadina - oftalmologico',
    'Nausedron': 'ondansetrona',
    'Vonau': 'ondansetrona',
    'Terramicina': 'oxitetraciclina + polimixina b - oftalmologico',
    'Creon': 'pancrealipase/pancreatina',
    'Pondera': 'paroxetina',
    'Cuprimine': 'penicilamina',
    'Solugel': 'peroxido de benzoila - topico',
    'Água Oxigenada': 'peroxido de hidrogenio (3% = 10 volumes)',
    'Nootropil': 'piracetam',
    'Notropil': 'piracetam',
    'Mestinon': 'piridostigmina',
    'Minipress': 'prazosina',
    'Predsim': 'prednisona/prednisolona',
    'Meticorten Humano': 'prednisona/prednisolona',
    'Predcort': 'prednisona/prednisolona',
    'Prelone': 'prednisona/prednisolona',
    'Dorene': 'pregabalina',
    'Fenergan': 'prometazina',
    'Naprix': 'ramipril',
    'Antak': 'ranitidina',
    'Label': 'ranitidina',
    'Rifocina': 'rifamicina - topico',
    'Rifotrat': 'rifamicina - topico',
    'Aerolin': 'salbutamol/albuterol',
    'Aerotrat': 'salbutamol/albuterol',
    'Zoloft': 'sertralina',
    'Viagra': 'sildenafila',
    'Cardomarin': 'silimarina',
    'Legalon': 'silimarina',
    'Steaton': 'silimarina',
    'Forfig': 'silimarina',
    'Sucrafilm': 'sucralfato',
    'Bactrim': 'sulfametoxazol + trimetoprima',
    'Azulfin': 'sulfassalazina',
    'Caspacil': 'sulfeto de selenio - topico',
    'Cialis': 'tadalafila',
    'Satuflan': 'tafluprosta - oftalmologico',
    'Lamisil': 'terbinafina',
    'Micosil': 'terbinafina – topico',
    'Lamisilate': 'terbinafina – topico',
    'Deposteron': 'testosterona',
    'Oculum': 'tetracaina + fenilefrina - oftalmologica',
    'Amplium': 'tinidazol',
    'Tobrex': 'tobramicina - oftalmologico',
    'Warfarina': 'varfarina',
    'Marevan': 'varfarina',
    'Encrise': 'vasopressina',
    'Buscopan': 'brometo de n-butilescopolamina/butilbrometo de escopolamina',
    'Claritin': 'loratadina',
    'Histadin': 'loratadina',
    'Loratamed': 'loratadina',
    'Alergaliv': 'loratadina',
    'Labirin': 'betaistina',
    'Betadine': 'betaistina',
    'Calcort': 'deflazacorte',
    'Deflaimmun': 'deflazacorte',
    'Deflanil': 'deflazacorte',
    'Levophed': 'norepinefrina | noradrenalina',
    'Hyponor': 'norepinefrina | noradrenalina',
    'Cedur': 'bezafibrato',
    'Dexa-Citoneurin': 'dexametasona',
    'Dexador': 'dexametasona',
    'Artrodar': 'diacereina',
    'Maxilerg': 'diclofenaco sodico - oftalmologico',
    'Still': 'diclofenaco sodico - oftalmologico',
    'Benzetacil': 'penicilina (benzilpenicilina)',
    'Histamin': 'dexclorfeniramina',
    'Polaramine': 'dexclorfeniramina',
    'Polaren': 'dexclorfeniramina',
    'Alergomine': 'dexclorfeniramina',
    'Rubromicina': 'eritromicina',
    'Tromaxil': 'eritromicina',
    'Prozac': 'fluoxetina',
    'Daforin': 'fluoxetina',
    'Prozen': 'fluoxetina',
    'Flozura': 'fluoxetina',
    'Fluxene': 'fluoxetina',
    'Rebetol': 'ribavirina',
    'Ribavirin': 'ribavirina',
    'Afrin': 'oximetazolina',
    'Rinidal': 'oximetazolina',
    'Oxifrin': 'oximetazolina',
    'Aturgyl': 'oximetazolina',
    'Helmizol': 'metronidazol',
    'Canderm': 'metronidazol',
    'Flagyl': 'metronidazol',
    'Hidazol': 'metronidazol',
    'Endonidazol': 'metronidazol',
    'Flagimax': 'metronidazol',
    'Metronack': 'metronidazol',
    'Levoxin': 'levofloxacino',
    'Tamiran': 'levofloxacino',
    'Tavaflox': 'levofloxacino',
    'Alevo': 'levofloxacino',
    'Levaflox': 'levofloxacino',
    'Tavagran': 'levofloxacino',
    'Annita': 'nitazoxanida',
    'Azox': 'nitazoxanida',
    'Rudite': 'nitazoxanida',
    'Venoruton': 'rutina | rutosideo | vitamina p',
    'Razapina': 'mirtazapina',
    'Remeron': 'mirtazapina',
    'Menelat': 'mirtazapina',
    'Cobavital': 'ciproeptadina',
    'Beritin': 'ciproeptadina',
    'Apevitin': 'ciproeptadina',
    'Apeviton': 'ciproeptadina',
    'Petivit': 'ciproeptadina',
    'Cobapetit': 'ciproeptadina',
    'Neurontin': 'gabapentina',
    'Progaba': 'gabapentina',
    'Gabaneurin': 'gabapentina',
    'Neurizen': 'gabapentina',
    'Neurocontrol': 'gabapentina',
    'Gamibetal': 'gabapentina',
    'Leucogen': 'timomodulina',
    'Fluimucil': 'acetilcisteina',
    'Monuril': 'fosfomicina trometamol',
    'Belemina': 'fosfomicina trometamol',
    'Traturil': 'fosfomicina trometamol',

    'Sepurin': 'metenamina',
    'Cystex': 'metenamina',
    'Digesan': 'bromoprida',
    'Plamet': 'bromoprida',
    'Digestil': 'bromoprida',
    'Fágico': 'bromoprida',
    'Movinau': 'bromoprida',
    'Pangest': 'bromoprida',
    'Zovirax': 'aciclovir',
    'Aciclofar': 'aciclovir',
    'Ziclovir': 'aciclovir',
    'Antivirax': 'aciclovir',
    'Herpesil': 'aciclovir',
    'Forfig': 'silimarina',
    'Lison': 'silimarina',
    'Cardomarin': 'silimarina',
    'Legalon': 'silimarina',
    'Steaton': 'silimarina',
    'Roferon': 'interferon alfa (humano)',
    'Alfainterferona': 'interferon alfa (humano)',
    'Maxitrol': 'neomicina + dexametasona + polimixina b – oftalmologico',
    'Maxiview': 'neomicina + dexametasona + polimixina b – oftalmologico',
    'Maxinom': 'neomicina + dexametasona + polimixina b – oftalmologico',

    'Celestone': 'betametasona sistemica',
    'Koide': 'betametasona sistemica',
    'Beclonato': 'betametasona sistemica',
    'Betaprospan': 'betametasona sistemica',
    'Betatrinta': 'betametasona sistemica',
    'Duoflam': 'betametasona sistemica',
    'Biproslam': 'betametasona sistemica',
    'Bedimza': 'betametasona sistemica',
    'Permese': 'betametasona sistemica',

    'Bontoss': 'bromexina',
    'Bisolvon': 'bromexina',
    'Bisolphar': 'bromexina',
    'Bromexpec': 'bromexina',
    'Bisuran': 'bromexina',
    'Broncatar': 'bromexina',

    'Sinvastacor': 'sinvastatina',
    'Sinvthal': 'sinvastatina',
    'Zocor': 'sinvastatina',
    'Sinvascor': 'sinvastatina',
    'Vaslip': 'sinvastatina',
    'Sinvastamed': 'sinvastatina',
    'Sinvaston': 'sinvastatina',
    'Clinfar': 'sinvastatina',
    'Sinvatrox': 'sinvastatina',
    'Sinvasmax': 'sinvastatina',
    'Menocol': 'sinvastatina',
    'Lipistatina': 'sinvastatina',

    'Efexor': 'cloridrato de venlafaxina',
    'Efexor XR': 'cloridrato de venlafaxina',
    'Adapta': 'cloridrato de venlafaxina',
    'Alenthus XR': 'cloridrato de venlafaxina',
    'Venforin': 'cloridrato de venlafaxina',
    'Venix XR': 'cloridrato de venlafaxina',
    'Venlaxin': 'cloridrato de venlafaxina',
    'Venlift OD': 'cloridrato de venlafaxina',
    'Vensate LP': 'cloridrato de venlafaxina',

    'Deca-Durabolin': 'decanoato de nandrolona',
    'Decadurabolin': 'decanoato de nandrolona',

    'Flunixin': 'flunixina meglumina',

    'Nina': 'melatonina',
    'Melatz': 'melatonina',


    'Mesacol': 'mesalazina',
    'Chron-asa 5': 'mesalazina',
    'Pentasa': 'mesalazina',

    'Tapazol': 'metimazol (tiamazol)',

    'Zidovir': 'zidovudina (azt)',

    'Ascorbato': 'acido ascorbico (vitamina c)',
    'Biovita C': 'acido ascorbico (vitamina c)',
    'Vitacin': 'acido ascorbico (vitamina c)',
    'Conthenc': 'acido ascorbico (vitamina c)',
    'Viter C': 'acido ascorbico (vitamina c)',
    'Energil': 'acido ascorbico (vitamina c)',
    'Redoxon': 'acido ascorbico (vitamina c)',
    'Cebion': 'acido ascorbico (vitamina c)',
    'Cevita': 'acido ascorbico (vitamina c)',
    'Vitasantina C': 'acido ascorbico (vitamina c)',

});